export enum ClientTypeEnum {
  Male = 1,
  Female = 2,
  Corporation = 3,
}

export enum ClientGenderEnum {
  Male = "1",
  Female = "2",
}

export enum ContracTypeEnum {
  Individual = "0",
  Corporation = "3",
}

export enum SubscriptionMode {
  Nothing = "nothing",
  MonthlyCancel = "monthly_cancel",
  ContinuousBilling = "continuous_billing",
}

export const getSubscriptionModeLabel = (mode: SubscriptionMode): string => {
  switch (mode) {
    case SubscriptionMode.Nothing:
      return "なし";
    case SubscriptionMode.MonthlyCancel:
      return "月額解約";
    case SubscriptionMode.ContinuousBilling:
      return "継続課金";
    default:
      return mode;
  }
};
